import { useMemo } from "react";

import { Image } from "@chakra-ui/react";

import FlinkLogoSmall from "images/logos/Flink-logo-small.png";
import JetBenJerrys from "images/logos/Jet-Ben-Jerrys.png";
import JetIqos from "images/logos/Jet-IQOS.png";
import JustEatBakery from "images/logos/Just-Eat-bakery.png";
import JustEatBeetsRoots from "images/logos/Just-Eat-beets-roots.png";
import JustEatLogo from "images/logos/Just-Eat-logo.png";
import JustEatPetLogo from "images/logos/Just-Eat-Pet-logo.png";
import JustEatReweFreshLogo from "images/logos/Just-Eat-Rewe-fresh.png";
import JustEatReweLogo from "images/logos/Just-Eat-Rewe-logo.png";
import JustEatHeinekenLogo from "images/logos/Just-Eat-stelzx-heineken-logo.png";
import JustEatVirtualLogo from "images/logos/Just-Eat-Virtual-logo.png";
import JustEatWeinfreundeLogo from "images/logos/Just-weinfreunde.png";
import UberEatsCarrefourLogo from "images/logos/Uber-eats-carrefour-logo.png";
import UberEatsLogoSmall from "images/logos/Uber-eats-logo-small.png";
import WoltLogoSmall from "images/logos/Wolt-logo-small.png";

export function SupplierLogo({ reseller }: { reseller: string }) {
  const supplierLogo = useMemo(() => {
    switch (reseller) {
      case "UBER-EATS-CARREFOUR":
        return UberEatsCarrefourLogo;
      case "WOLT":
      case "WOLT-BYOC":
      case "WOLT-BYOC-PLUS":
        return WoltLogoSmall;
      case "UBER-EATS":
        return UberEatsLogoSmall;
      case "JUST-EAT":
        return JustEatLogo;
      case "JUST-EAT-REWE":
        return JustEatReweLogo;
      case "JUST-EAT-WEINFREUNDE":
        return JustEatWeinfreundeLogo;
      case "JUST-EAT-REWEREADY":
        return JustEatReweFreshLogo;
      case "JUST-EAT-VIRTUAL":
        return JustEatVirtualLogo;
      case "JUST-EAT-BEETS-ROOTS":
        return JustEatBeetsRoots;
      case "JUST-EAT-BAKERY":
        return JustEatBakery;
      case "JUST-EAT-BEN-JERRYS":
        return JetBenJerrys;
      case "JUST-EAT-IQOS":
        return JetIqos;
      case "JUST-EAT-HEINEKEN":
        return JustEatHeinekenLogo;
      case "JUST-EAT-PET":
        return JustEatPetLogo;
      default:
        return FlinkLogoSmall;
    }
  }, [reseller]);

  return (
    <Image
      role="img"
      alt="logo-supplier"
      src={supplierLogo}
      height="28px"
      width="auto"
      loading="lazy"
    />
  );
}
